
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Innovacrystaonrentinpune() {



    const cardData =
    {
        keyword: '  Innova Crysta on Rent in Pune ',
        heading: 'Skyline Cabs: Innova Crysta on Rent in Pune ',
        headingDescription: 'Skyline Cabs offers premium Innova Crysta on Rent in Pune for a luxurious and spacious travel experience. Perfect for family outings, corporate travel, or outstation trips, our well-maintained Innova Crysta vehicles provide superior comfort, ample luggage space, and a smooth ride. With experienced chauffeurs, flexible rental plans, transparent pricing, and 24/7 customer support, Skyline Cabs ensures your journey is safe and stress-free. Book your Innova Crysta in Pune today and enjoy premium travel with complete peace of mind.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Skyline Cabs offers reliable Innova cab services from Pune to Mumbai, perfect for families, groups, or those needing extra space. Enjoy a smooth journey with experienced drivers and comfortable 6-7 seater vehicles ideal for long-distance travel."
    },
    {
      "name": "Pune to Mumbai Airport Drop Innova",
      "description": "Get an Innova cab for direct drop-offs from Pune to Mumbai Airport. Our cabs are available 24x7 with timely pickups, air-conditioned interiors, and ample luggage space for a relaxed airport transfer experience."
    },
    {
      "name": "Mumbai Airport to Pune Innova",
      "description": "Arriving at Mumbai Airport and heading to Pune? Skyline Cabs provides Innova cabs with spacious seating and professional chauffeurs. Pre-book and get airport pickup with meet-and-greet services and zero wait time."
    },
    {
      "name": "Pune Mumbai Innova Rental",
      "description": "Rent an Innova for travel between Pune and Mumbai at competitive rates. Whether it's a one-way or round trip, we provide well-maintained vehicles with flexible booking hours and options for both corporate and personal use."
    },
    {
      "name": "Pune to Mumbai Airport Innova",
      "description": "Book a Pune to Mumbai Airport Innova cab for hassle-free, direct airport transfers. Enjoy safe driving, sanitized cars, and fixed rates with no hidden fees. Best suited for families or group airport commutes."
    },
    {
      "name": "Innova Crysta on Rent in Pune Airport",
      "description": "Skyline Cabs offers Innova Crysta rentals directly from Pune Airport. Whether for outstation trips or local sightseeing, our premium vehicles provide unmatched comfort and performance for all your travel needs."
    },
    {
      "name": "Innova per km Rate in Pune",
      "description": "Our Innova rental in Pune is available at ₹16–₹18 per km depending on trip type and duration. Get transparent billing, GPS-enabled vehicles, and experienced drivers for every trip across Maharashtra."
    },
    {
      "name": "Pune to Andheri Innova Crysta",
      "description": "Travel from Pune to Andheri in style with our Innova Crysta service. Perfect for business travelers or families, this ride ensures comfort, safety, and reliability at fixed, all-inclusive fares."
    },
    {
      "name": "Pune to Mumbai Innova Crysta",
      "description": "Book a premium Innova Crysta from Pune to Mumbai with Skyline Cabs. Enjoy plush seating, air-conditioning, spacious interiors, and professional service for the ultimate travel experience between the two cities."
    },
    {
      "name": "Pune to Mumbai Oneway Innova Crysta",
      "description": "Looking for a one-way Innova Crysta ride from Pune to Mumbai? Skyline Cabs offers discounted fares for one-way trips without compromising on service quality or car comfort."
    },
    {
      "name": "Pune to Mumbai Innova",
      "description": "Skyline Cabs provides regular Innova cabs from Pune to Mumbai. Our 6-seater models come equipped with modern features, spacious legroom, and experienced drivers to ensure a stress-free journey."
    },
    {
      "name": "Pune Airport to Mumbai Airport Innova Cab",
      "description": "Travel directly from Pune Airport to Mumbai Airport in an Innova cab. Our service is ideal for transit passengers needing a reliable, comfortable intercity transfer with ample luggage space and professional assistance."
    },
    {
      "name": "Outstation Innova Car Rental Mumbai",
      "description": "Need an Innova for an outstation trip from Mumbai? Skyline Cabs offers outstation Innova rentals with flexible packages—perfect for weekend getaways, business trips, or pilgrimages. Clean, safe, and affordable."
    },
    {
      "name": "Innova Crysta on Rent in Mumbai for Outstation Trip",
      "description": "Skyline Cabs rents Innova Crysta cars in Mumbai for outstation travel. Our fleet is well-maintained, with AC, push-back seats, and professional chauffeurs. Ideal for hill stations, city tours, and long family journeys."
    },
    {
      "name": "Innova per km Rate for Outstation",
      "description": "Innova Crysta and regular Innova cabs are available for outstation use at ₹17–₹20/km. Minimum kilometers per day and driver allowance applicable. Contact Skyline Cabs for customized outstation tour packages."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Innova Cab", "Pune to Mumbai Airport Drop Innova"],
    ["Mumbai Airport to Pune Innova", "Pune Mumbai Innova Rental"],
    ["Pune to Mumbai Airport Innova", "Innova Crysta on Rent in Pune Airport"],
    ["Innova per km Rate in Pune", "Pune to Andheri Innova Crysta"],
    ["Pune to Mumbai Innova Crysta", "Pune to Mumbai Oneway Innova Crysta"],
    ["Pune to Mumbai Innova", "Pune Airport to Mumbai Airport Innova Cab"],
    ["Outstation Innova Car Rental Mumbai", "Innova Crysta on Rent in Mumbai for Outstation Trip"],
    ["Innova per km Rate for Outstation"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Innova Crysta Rental in Pune",
        "WhyChoosedescription": "We provide dependable and hassle-free Innova Crysta rental services in Pune, ideal for local travel, outstation trips, corporate use, and family tours."
    },
    {
        "WhyChooseheading": "Spacious and Premium Comfort",
        "WhyChoosedescription": "Innova Crysta is known for its plush interiors, ample legroom, and luxurious seating. Perfect for long journeys, our vehicles ensure top-tier comfort for every passenger."
    },
    {
        "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
        "WhyChoosedescription": "All our Innova Crystas are regularly serviced and thoroughly sanitized before every ride to guarantee safety and cleanliness for your journey."
    },
    {
        "WhyChooseheading": "Experienced and Courteous Drivers",
        "WhyChoosedescription": "Our professional drivers are experienced, polite, and familiar with major routes in and around Pune, ensuring a smooth and safe travel experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Get the best value for your money with our competitive rates and no hidden charges. Our rental packages are clearly defined for both local and outstation use."
    },
    {
        "WhyChooseheading": "Flexible Rental Options",
        "WhyChoosedescription": "We offer hourly, daily, and outstation rental plans for Innova Crysta in Pune to suit your unique travel requirements—be it a few hours or multiple days."
    },
    {
        "WhyChooseheading": "24/7 Availability and Support",
        "WhyChoosedescription": "Our Innova Crysta rental service in Pune is available round-the-clock. Whether it’s a day trip or an emergency ride, we’re just a call or click away."
    },
    {
        "WhyChooseheading": "Ideal for Family & Group Travel",
        "WhyChoosedescription": "With a seating capacity of 6–7 passengers, Innova Crysta is perfect for family outings, airport transfers, wedding events, and group tours from Pune."
    }
]






















    }

    const faqData = [
        {
            id: 1,
            question: 'How can I rent an Innova Crysta in Pune with Skyline Cabs?',
            answer:
                'Renting an Innova Crysta in Pune with Skyline Cabs is simple. Just visit our website or mobile app, choose Innova Crysta as your preferred vehicle, enter your travel details, and confirm the booking. You can also book by calling our customer support.',
        },
        {
            id: 2,
            question: 'What are the benefits of renting an Innova Crysta in Pune?',
            answer:
                'Innova Crysta offers spacious interiors, premium comfort, advanced safety features, and smooth performance, making it ideal for long journeys, family trips, and business travel in and around Pune.',
        },
        {
            id: 3,
            question: 'Is Innova Crysta available for both local and outstation trips in Pune?',
            answer:
                'Yes, you can rent an Innova Crysta for both local travel within Pune and outstation trips to destinations like Mumbai, Lonavala, Mahabaleshwar, and more.',
        },
        {
            id: 4,
            question: 'What is included in the rental fare for an Innova Crysta in Pune?',
            answer:
                'The rental fare includes fuel, driver charges, tolls, and taxes, unless otherwise specified. We provide upfront pricing with no hidden charges for full transparency.',
        },
        {
            id: 5,
            question: 'Can I book an Innova Crysta for a one-way trip from Pune?',
            answer:
                'Yes, Skyline Cabs offers one-way rentals for Innova Crysta. You can book a one-way trip from Pune to cities like Mumbai, Nashik, Shirdi, and more.',
        },
        {
            id: 6,
            question: 'Can I rent an Innova Crysta in Pune for corporate or group travel?',
            answer:
                'Absolutely! The Innova Crysta is perfect for corporate events, business meetings, and group travel. Contact us for customized packages for corporate clients.',
        },
        {
            id: 7,
            question: 'Are the Innova Crysta vehicles clean and well-maintained?',
            answer:
                'Yes, all our vehicles are regularly cleaned, sanitized, and maintained to ensure a safe and comfortable journey for every passenger.',
        },
        {
            id: 8,
            question: 'What are the payment options for renting an Innova Crysta in Pune?',
            answer:
                'You can pay online using credit/debit cards, UPI, net banking, or choose to pay in cash after your ride. All online payments are secure and convenient.',
        },
        {
            id: 9,
            question: 'Can I modify or cancel my Innova Crysta booking in Pune?',
            answer:
                'Yes, we offer flexible modification and cancellation options. You can make changes to your booking through our app, website, or by contacting customer support.',
        },
        {
            id: 10,
            question: 'Why should I rent an Innova Crysta from Skyline Cabs in Pune?',
            answer:
                'Skyline Cabs offers premium vehicles, transparent pricing, experienced drivers, and exceptional customer service. Our Innova Crysta rentals ensure you travel in style and comfort, whether it’s for business or leisure.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Rented an Innova Crysta in Pune for a family trip and it was fantastic. The car was in excellent condition, and the driver was very professional. Highly recommend Skyline Cabs!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Great experience with the Innova Crysta rental in Pune. Spacious, clean, and very comfortable. Booking was easy too. Will use again!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta on Rent in Pune",
  "image": "https://skylinecabs.com/assets/images/innova-crysta-on-rent-pune.jpg",
  "description": "Hire Innova Crysta on rent in Pune with Skyline Cabs for spacious, comfortable, and premium travel. Ideal for family trips, business travel, and outstation tours — available 24/7 with professional chauffeurs.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8927"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/innova-crysta-on-rent-in-pune"
  }
};



      
      

    return (
        <div>
<Helmet>
  <title>Innova Crysta on Rent in Pune | Luxury Car Rental 24/7 | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Hire Innova Crysta on rent in Pune with Skyline Cabs for spacious, comfortable, and premium travel. Ideal for family trips, business travel, and outstation tours — available 24/7 with professional chauffeurs." 
  />
  <meta 
    name="keywords" 
    content="Innova Crysta on Rent in Pune, Rent Innova Crysta Pune, Innova Crysta Cab Booking Pune, Premium Car Rental Pune, 7 Seater Car Hire Pune, SUV on Rent Pune, Outstation Innova Crysta Pune, AC Car Rental Pune, Skyline Cabs Innova Crysta, Pune Luxury Cab Service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/65.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystaonrentinpune;